import { HbrStarIcon, HbrStarIconOutline } from "../newComponents/Mycustomsvgicons";

const RatingStar = ({isStarFilled, starIndex, handleClick}) => {

    return ( 
        <div className="ratingstar" onClick={()=>handleClick(starIndex)} key={starIndex}>
            {isStarFilled ? <HbrStarIcon width={"3em"} height={"3em"} fillColour={"orange"}/> : <HbrStarIconOutline width={"3em"} height={"3em"}/>}
        </div> 
    );
}
export default RatingStar;